import React from "react";
import styles from "../styles/common.module.css";

const Services = () => {
  return (
    <div className={styles.servicesMainContainer}>
      <div className={styles.servicesImageContainer}>
        <div className={styles.servicesOverlay}>
          <h2> 成長に伴走するワンストップITパートナー</h2>
          <div
            className={`${styles.serviceCards} ${styles.mobileServiceCards}`}
          >
            <div className={styles.serviceCard}>
              <h3>プロアクティブメンテナンス</h3>
              <p className={styles.subheading}>障害を未然に回避する</p>
              <hr />
              <p>
                DG FutureTechは、高度な24時間365日の監視を活用して継続的なシステム監視を実現するとともに、プロアクティブなメンテナンスによってコスト負担を生じる障害を防ぎ、IT資産の耐用年数を延ばします。
              </p>
            </div>
            <div className={styles.serviceCard}>
              <h3>定期的なセキュリティ監査</h3>
              <p className={styles.subheading}>継続的な保護の確保</p>
              <hr />
              <p>
                当社セキュリティ監査は標準装備として脆弱性を特定し、システムを強化して、脅威に対する最大限の保護を保証するように設計されています。当社は業界のベストプラクティスを実践し、お客様のビジネスを護ります。
              </p>
            </div>
            <div className={styles.serviceCard}>
              <h3>専門知識と拡張性</h3>
              <p>エンドツーエンドの専門性と拡張性</p>
              <hr />
              <p>
                当社の専門知識により、お客様のITインフラストラクチャが拡張可能になり、将来の成長に対応できるようになります。小規模なスタートアップ企業から大企業まで、お客様のニーズに合わせたソリューションを提供します。
              </p>
            </div>
            <div className={styles.serviceCard}>
              <h3>コストメリットのある品質</h3>
              <p>運用コストの削減</p>
              <hr />
              <p>
                当社のソリューションは、高品質のサービスを維持しながらIT関連のコストを最小限に抑えるように設計されています。当社は、費用対効果の高い戦略を実装し、最先端のテクノロジーを活用することで、お客様の予算の最適化をお手伝いします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;